export enum DocumentFolderTypeEnum {
  Library     = '0000001E-1000-0000-0000-000000000001',
  Lecture     = '0000001E-1000-0000-0000-000000000002',
  Patient     = '0000001E-1000-0000-0000-000000000003',
  PatientRoot = '0000001E-1000-0000-0000-000000000004',
  PatientImport = '0000001E-1000-0000-0000-000000000005'
}
